import axios from "axios";
import React, { useState } from "react";
import { IOrganization } from "../../prep-sa-individual-status-report/models/prep-self-assessment-individual-status-report-models";
import { IEpiProps, ILPReviewerData, PlansForPLYear } from "../models/ilp-page-models";
import { useILPPageContext, useILPPageDispatch } from "../reducers/ilp-page-reducers";
import { PlansForLearnerDisplay } from "./plans-for-learner-display";
interface IProps {

}
interface IContextProps {
    epiProps: IEpiProps;
    organizations: Array<IOrganization>;
    selectedOrg: string;
    userFullName: string;
    plans: Array<PlansForPLYear>
}

export const IlpPlans = (props: IProps) => {
    const { plans, epiProps }: IContextProps = useILPPageContext();
    let hasPlans = plans && plans.length > 0;
    const [levelsShown, setLevelsShown] = useState({});

    const toggleLevel = id => {
        setLevelsShown(prevLevelsShown => ({
            ...prevLevelsShown,
            [id]: !prevLevelsShown[id]
        }));
    };


    return (
        <div>
            {hasPlans &&
                plans.map(plan => <>
                    <div>
                        <div id={`panel-` + plan.plYear} className="ilp-level-container" key={plan.plYear}>
                            <button className="ilp-level unbutton" onClick={() => {toggleLevel(plan.plYear) }}>
                                <span>{plan.plYear}</span>
                                <span className={`ilp-level-trigger  ${levelsShown[plan.plYear] ? 'closed' : 'open'}`}> </span>
                            </button>
                        </div>
                        {!levelsShown[plan.plYear] && 
                            plan.plans.map(plan => <PlansForLearnerDisplay plansForLearner={plan} />)}
                    </div>
                </>)}

            {!hasPlans &&
                <div className="prep-page-description rich-text">
                    <p dangerouslySetInnerHTML={{ __html: epiProps.noPlansMessage }} />
                </div>}
        </div>
    )
}